import { KeyboardEvent, ReactElement } from 'react';
import { Sheet, SheetList } from '@methodset/calculator-ts';
import { Select } from 'antd';
import { FilterInput } from 'components/FilterInput/FilterInput';
import { KeyUtils } from 'utils/KeyUtils';
import classNames from 'classnames';
import update from 'immutability-helper';
import './CellRefEditor.less';

export type CellData = {
    sheetId?: string,
    cellId?: string
}
export type BlurCallback = () => void;
export type ChangeCallback = (value: CellData, isCleared: boolean) => void;

export type CellRefEditorProps = {
    className?: string,
    value: CellData,
    sheets?: SheetList,
    allowClear: boolean,
    onCommit: BlurCallback,
    onChange: ChangeCallback
};

export const CellRefEditor = (props: CellRefEditorProps): ReactElement => {

    const handleSheetChange = (sheetId: string | undefined): void => {
        const value = update(props.value, {
            sheetId: { $set: sheetId }
        });
        props.onChange(value, false);
    }

    const handleCellChange = (cellId: string | undefined): void => {
        const value = update(props.value, {
            cellId: { $set: cellId }
        });
        props.onChange(value, false);
    }

    const handleClear = (): void => {
        const value = update(props.value, {
            sheetId: { $set: undefined }
        });
        props.onChange(value, true);
    }

    const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>): void => {
        if (KeyUtils.isCommit(e)) {
            e.stopPropagation();
            e.preventDefault();
            props.onCommit();
        }
    }

    return (
        <div className={classNames("x-cellrefeditor", props.className)}>
            <Select
                className="x-cellrefeditor-sheet"
                placeholder="Select a sheet."
                value={props.value.sheetId}
                allowClear={props.allowClear}
                onBlur={() => props.onCommit()}
                onClear={() => handleClear()}
                onChange={(sheetId) => handleSheetChange(sheetId)}
            >
                {props.sheets?.map((sheet: Sheet) => (
                    <Select.Option
                        key={sheet.id}
                        value={sheet.name}
                    >
                        {sheet.name}
                    </Select.Option>
                ))}
            </Select>
            <FilterInput
                className="x-cellrefeditor-cell"
                placeholder="Enter a cell."
                value={props.value.cellId}
                tester={(value: string) => /^[0-9A-Z]*$/.test(value)}
                onBlur={() => props.onCommit()}
                onKey={(e) => handleKeyDown(e)}
                onChange={(e) => handleCellChange(e)}
            />
        </div>
    )
}
